import React from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';
import { getInternalBaseUrl } from '../../common/global.js';

import styles from './Place.module.scss';

export default class Place extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onClickPlace = this.onClickPlace.bind(this);

    this.onDragPlaceStart = this.onDragPlaceStart.bind(this);
    this.onDragPlaceOver = this.onDragPlaceOver.bind(this);
    this.onDropPlace = this.onDropPlace.bind(this);
  }

  onClickPlace(place) {
    // TODO: Implement me
  }

  onDragPlaceStart(e, placeNumber) {
    e.dataTransfer.setData('text/plain', placeNumber - 1);

    e.stopPropagation();
  }

  onDragPlaceOver(e, placeNumber) {
    e.preventDefault();
    e.stopPropagation(); // Don't send it further
    this.props.highlightDestinationFunc(placeNumber);
  }

  onDropPlace(e, category, placeNumber) {
    if (category === 'complete') {
      const from = e.dataTransfer.getData('text');
      const to = placeNumber - 1;
      this.props.onSwapPlacesFunc(from, to);
    }

    e.stopPropagation();
  }

  renderPlace(place, placeNumber) {
    if (isEmpty(place)) return <div />;

    const { id = '', name = '', note = {} } = place;

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let paddingRight,
      paddingBottom = '0px';

    if (this.props.highlight === placeNumber) {
      borderColor = '#52A8EF';
      borderStyle = 'dashed';
      paddingRight = '18px';
      paddingBottom = '8px';
    }

    let gotToPlaceUrl = getInternalBaseUrl().places + '?id=' + id;
    return (
      <Link
        to={gotToPlaceUrl}
        style={{ textDecoration: 'none', color: 'inherit' }}
        onClick={(e) => {
          // This has been done to place default onClick behaviour of the Link.
          e.preventDefault();
        }}
        draggable
        onDragStart={(e) => this.onDragPlaceStart(e, placeNumber)}
        onDragOver={(e) => this.onDragPlaceOver(e, placeNumber)}
        onDrop={(e) => this.onDropPlace(e, 'complete', placeNumber)}
      >
        <div
          style={{
            borderColor,
            borderStyle,
            paddingRight,
            paddingBottom,
          }}
        >
          <ListItem className={styles.root} onClick={() => this.onClickPlace(place)}>
            <div className={styles.mediumColumn}>
              <span className={styles.capitalizedBoldFont}>{name}</span>
            </div>
            <Tooltip title={note.public || ''}>
              <div className={styles.defaultColumnLength}>
                <span
                  style={{
                    fontSize: '12px',
                  }}
                >
                  {note.public || ''}
                </span>
              </div>
            </Tooltip>
          </ListItem>
        </div>
      </Link>
    );
  }

  render() {
    let { placeNumber, place } = this.props;

    return this.renderPlace(place, placeNumber);
  }
}
